import InputLabel from "@mui/material/InputLabel";
import {
	GoogleMap,
	Marker,
	StandaloneSearchBox,
	useLoadScript,
} from "@react-google-maps/api";
import { AnimatePresence } from "framer-motion";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { ChromePicker } from "react-color";
import CloseIcon from "../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../components/FiltroV2/FiltroV2";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalConfirmacao2 from "../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import ModalUsuarioMotorista from "../../../components/ModalUsuarioMotorista/ModalUsuarioMotorista.tsx";
import ModalVincular from "../../../components/ModalVincular/ModalVincular.tsx";
import { TabelaVirtualizadaGenerica } from "../../../components/TabelaVirtualizadaGenerica/TabelaVirtualizadaGenerica.tsx";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { colunasEmpresaInicial } from "../../../contexts/ContextConstants.ts";
import MultiplosFiltrosRedux from "../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import { useToast } from "../../../contexts/ToastContext.tsx";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import {
	buscarPostalCode,
	parseAddressFromComponents,
	pickBestGeocodeResult,
} from "../../../core/utils/geoMapsHandlers.ts";
import { documentoValido } from "../../../core/utils/validators.ts";
import { useRowClick } from "../../../hooks/useRowClick.ts";
import { cnpjMask } from "../../../regex/cnpjMask";
import { cpfMask } from "../../../regex/cpfMask";
import {
	cadastraClienteComEndereco,
	deleteClientePorId,
	editaClientePorId,
	getCliente,
	getClientePorId,
} from "../../../services/ModuloGerenciador/Cliente";
import { getClienteSearch } from "../../../services/ModuloGerenciador/Search";
import {
	getUserClientes,
	vincularUsuario,
} from "../../../services/ModuloGerenciador/Usuario";
import "./Cliente.css";

const defaultLat = -23.55052;
const defaultLng = -46.633308;

const itensFiltro = [
	{
		nomeColuna: "Nome Fantasia",
		field: "nomeFantasia",
	},
	{
		nomeColuna: "Razão Social",
		field: "razaoSocial",
	},
	{
		nomeColuna: "CNPJ",
		field: "cnpj",
	},
];

function Cliente(props) {
	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);
	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);
	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);
	const { profile, hasRegra, tabelaEmpresa, shouldSearchDependencies } =
		useProfile();
	const { showToast } = useToast();

	const searchBoxRef = useRef(null);

	const [mapInstance, setMapInstance] = useState(null);
	const [zoom, setZoom] = useState(6);
	const [isMapLoaded, setIsMapLoaded] = useState(false);
	const [lat, setLat] = useState(defaultLat);
	const [lng, setLng] = useState(defaultLng);
	const [polygon, setPolygon] = useState({ paths: [] });
	const [marker, setMarker] = useState(null);
	const [, setShowFirstPointMarker] = useState(false);
	const [drawnPolygon, setDrawnPolygon] = useState(null);
	const [disableInputs, setDisableInputs] = useState(true);
	const [disabledCep, setDisabledCep] = useState(true);
	const [disableCnpj, setDisableCnpj] = useState(false);
	const [valuesPesquisa, setValuesPesquisa] = useState([]);
	const [dadosTabelaCopia, setDadosTabelaCopia] = useState([]);
	const [dadosTabela, setDadosTabela] = useState([]);
	const [telaCadastro, setTelaCadastro] = useState(false);
	const [editando, setEditando] = useState(false);
	const [loading, setLoading] = useState(true);
	const [values, setValues] = useState({
		rua: "",
		numero: 0,
		cidade: "",
		cep: "",
		bairro: "",
		razaoSocial: "",
		nomeFantasia: "",
		apelido: "",
		cnpj: "",
		tempoDiariaMinutos: 0,
	});
	const [clienteLatLng, setClienteLatLng] = useState({
		lat: defaultLat,
		lng: defaultLng,
	});
	const [dadosUsuarioMotorista, setDadosUsuarioMotorista] = useState([]);
	const [validator, setValidator] = useState({
		validatorCnpj: "true",
		validatorApelido: "true",
		validatorNomeFantasia: "true",
		validatorRazaoSocial: "true",
		validatorRua: "true",
		validatorCidade: "true",
		validatorCep: "true",
	});
	const [open, setOpen] = useState(false);
	const [textoSucesso, setTextoSucesso] = useState("");
	const [textoErro, setTextoErro] = useState("");
	const [isMapa, setIsMapa] = useState(true);
	const [tipoGeometria, setTipoGeometria] = useState(false);
	const [openToastSucesso, setOpenToastSucesso] = useState(false);
	const [openToastErro, setOpenToastErro] = useState(false);
	const [openUsuario, setOpenUsuario] = useState(false);
	const [openUsuarioMotorista, setOpenUsuarioMotorista] = useState(false);
	const [openConfirmar, setOpenConfirmar] = useState(false);
	const [openGerar, setOpenGerar] = useState(false);
	const [listaUsuarios, setListaUsuario] = useState([]);
	const [usuarioId, setUsuarioId] = useState();
	const [, setNomeUsuario] = useState();
	const [semAutorizacao, setSemAutorizacao] = useState(false);
	const [semAutorizacaoGerarLogin, setSemAutorizacaoGerarLogin] =
		useState(false);
	const [error, setError] = useState(false);
	const libraries = useMemo(() => ["places"], []);
	const { isLoaded, loadError } = useLoadScript({
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
		libraries,
	});

	const fetchAddressFromCoords = async (lat, lng) => {
		if (!isFinite(lat) || !isFinite(lng)) {
			console.error("Erro: Coordenadas inválidas recebidas.", { lat, lng });
			return;
		}

		const newPoint = { latitude: lat, longitude: lng };
		const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

		try {
			const response = await fetch(apiUrl);
			const data = await response.json();

			if (!data.results?.length) {
				showToast(
					"Nenhum endereço encontrado para essas coordenadas.",
					"error"
				);
				return;
			}

			const best = pickBestGeocodeResult(data.results, { lat, lng });

			if (!best?.address_components) {
				showToast("Endereço não encontrado.", "error");
				return;
			}

			const parsed = parseAddressFromComponents(best.address_components);

			const fallbackCep = buscarPostalCode(data.results).replace("-", "");

			setLat(lat);
			setLng(lng);
			setValues((current) => ({
				...current,
				latitude: lat,
				longitude: lng,
				polygon: [{ latitude: lat, longitude: lng }],
				rua: parsed.rua || "",
				numero: parsed.numero || 0,
				cidade: parsed.cidade || "",
				bairro: parsed.bairro || "",
				cep: parsed.cep || fallbackCep || "",
			}));

			setValidator((current) => ({
				...current,
				validatorRua: parsed.rua ? "true" : "false",
				validatorCidade: parsed.cidade ? "true" : "false",
				validatorCep: parsed.cep || fallbackCep ? "true" : "false",
			}));

			setMarker({ lat, lng });
			setDisableInputs(false);
			setDisabledCep(false);
		} catch (error) {
			console.error("Erro ao buscar endereço:", error);
			showToast("Erro ao buscar endereço no Google.", "error");
		}
	};

	const handlePlacesChanged = useCallback(() => {
		const places = searchBoxRef.current?.getPlaces();
		const first = places?.[0];

		if (!first?.geometry?.location) {
			showToast("O local selecionado não possui coordenadas válidas.", "error");
			return;
		}

		const location = first.geometry.location;
		const newLat = location.lat();
		const newLng = location.lng();

		setLat(newLat);
		setLng(newLng);
		setZoom(14);

		if (first.address_components?.length) {
			const parsed = parseAddressFromComponents(first.address_components);

			setValues((current) => ({
				...current,
				latitude: newLat,
				longitude: newLng,
				polygon: [{ latitude: newLat, longitude: newLng }],
				rua: parsed.rua || "",
				numero: parsed.numero || 0,
				cidade: parsed.cidade || "",
				bairro: parsed.bairro || "",
				cep: parsed.cep || "",
			}));

			setValidator((current) => ({
				...current,
				validatorRua: parsed.rua ? "true" : "false",
				validatorCidade: parsed.cidade ? "true" : "false",
				validatorCep: parsed.cep ? "true" : "false",
			}));

			setMarker({ lat: newLat, lng: newLng });
			setDisableInputs(false);
			setDisabledCep(false);
			return;
		}

		fetchAddressFromCoords(newLat, newLng);
	}, [fetchAddressFromCoords]);

	const removePolygon = useCallback(() => {
		if (drawnPolygon) {
			drawnPolygon.setMap(null);
			setDrawnPolygon(null);
		}
	}, [drawnPolygon]);

	const limparGeoms = useCallback(() => {
		setMarker(null);
		setDrawnPolygon(null);
		setPolygon({ paths: [] });
		removePolygon();
		setValues((current) => ({
			...current,
			latitude: null,
			longitude: null,
			polygon: null,
		}));
		setTipoGeometria(!tipoGeometria);
	}, [removePolygon]);

	const buscarEmbarcador = useCallback(async () => {
		setLoading(true);
		await getCliente(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
				setDadosTabelaCopia(result.data);
				setTabelaRedux({});
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	}, [profile?.token, setTabelaRedux]);

	const buscarUsuariosClientes = useCallback(async () => {
		await getUserClientes(profile?.token)
			.then((result) => {
				setListaUsuario(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	}, [profile?.token]);

	const gerarUsuario = useCallback(async () => {
		const usuarioVinculo = {
			clienteId: tabelaRedux.colunaSelecionada,
			usuarioClientesId: usuarioId,
		};
		await vincularUsuario(usuarioVinculo, profile?.token)
			.then((result) => {
				setOpenGerar(false);
				buscarEmbarcador();
				setTextoSucesso("Vinculado Com Sucesso");
				setOpenToastSucesso(true);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	}, [
		usuarioId,
		profile?.token,
		tabelaRedux.colunaSelecionada,
		buscarEmbarcador,
	]);

	const handleCloseCadastro = useCallback(() => {
		setValues({});
		setTelaCadastro(false);
		setMarker(null);
		setEditando(false);
		setDisableInputs(true);
		setDisabledCep(true);
		setTabelaRedux({});
		setIsMapa(false);
		limparGeoms();
		setError(false);
		setMapInstance(null);
		setIsMapLoaded(false);
	}, [setTabelaRedux, limparGeoms]);

	const title = useMemo(() => {
		if (editando) return "Detalhes de Cliente";
		if (telaCadastro) return "Cadastro de Cliente";
		return "Clientes";
	}, [editando, telaCadastro]);

	const markerPosition = useMemo(() => {
		if (!isFinite(lat) || !isFinite(lng)) return null;
		return { lat, lng };
	}, [lat, lng]);

	const enderecoParcialmentePreenchido = useMemo(() => {
		return Boolean(values.rua || values.cidade || values.cep || values.bairro);
	}, [values]);

	const enderecoTotalmentePreenchido = useMemo(() => {
		return Boolean(values.rua && values.cidade && values.cep);
	}, [values]);

	const validaDadosCliente = useCallback(() => {
		if (!values.nomeFantasia) {
			setValidator((current) => ({
				...current,
				validatorNomeFantasia: "false",
			}));
		}
		if (!values.razaoSocial) {
			setValidator((current) => ({
				...current,
				validatorRazaoSocial: "false",
			}));
		}
		if (!values.apelido) {
			setValidator((current) => ({
				...current,
				validatorApelido: "false",
			}));
		}
	}, [values]);

	const validaEnderecoCliente = useCallback(() => {
		if (!values.rua) {
			setValidator((current) => ({
				...current,
				validatorRua: "false",
			}));
		}
		if (!values.cidade) {
			setValidator((current) => ({
				...current,
				validatorCidade: "false",
			}));
		}
		if (!values.cep) {
			setValidator((current) => ({
				...current,
				validatorCep: "false",
			}));
		}
	}, [values.rua, values.cidade, values.cep]);

	const dadosClienteValidos = useMemo(() => {
		return (
			values.razaoSocial &&
			values.nomeFantasia &&
			values.apelido &&
			validator.validatorNomeFantasia === "true" &&
			validator.validatorRazaoSocial === "true" &&
			validator.validatorApelido === "true"
		);
	}, [
		values.razaoSocial,
		values.nomeFantasia,
		values.apelido,
		validator.validatorApelido,
		validator.validatorNomeFantasia,
		validator.validatorRazaoSocial,
	]);

	const dadosFormularioValido = useMemo(() => {
		return Boolean(
			dadosClienteValidos &&
				(!enderecoParcialmentePreenchido || enderecoTotalmentePreenchido)
		);
	}, [
		dadosClienteValidos,
		enderecoParcialmentePreenchido,
		enderecoTotalmentePreenchido,
	]);

	const cadastrar = useCallback(async () => {
		if (!documentoValido(values.cnpj)) {
			setTextoErro("CPF/CNPJ inválido");
			setOpenToastErro(true);
			setValidator((current) => ({ ...current, validatorCnpj: "false" }));
			return;
		}
		if (values.cep.length !== 8) {
			setTextoErro("CEP inválido");
			setOpenToastErro(true);
			setValidator((current) => ({ ...current, validatorCep: "false" }));
			return;
		}

		setLoading(true);
		await cadastraClienteComEndereco(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarEmbarcador();
					setDadosRequestControllerRedux("Fechar Modal Cliente");
					setTabelaRedux({});
					showToast("Cadastrado Com Sucesso", "success");
					shouldSearchDependencies();
					limparGeoms();
					setTelaCadastro(false);
					setMarker(null);
					setValues({});
					setDisableInputs(true);
					setDisabledCep(true);
					if (!!props.onCloseModal) {
						props.onCloseModal();
					}
				}
			})
			.catch((error) => {
				showToast(
					typeof error.response.data === "string"
						? error.response.data
						: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					"error"
				);
			});
		setLoading(false);
	}, [
		values,
		validator,
		profile?.token,
		buscarEmbarcador,
		setDadosRequestControllerRedux,
		setTabelaRedux,
		limparGeoms,
	]);

	const buscarSearch = useCallback(async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getClienteSearch(profile?.token, pesquisaFormatada)
			.then((result) => {
				setDadosTabela(result.data);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
			});
		setLoading(false);
	}, [profile?.token, multiplosFiltrosRedux, valuesPesquisa]);

	const editar = useCallback(async () => {
		if (!documentoValido(values.cnpj)) {
			setTextoErro("CPF/CNPJ inválido");
			setOpenToastErro(true);
			setValidator((current) => ({ ...current, validatorCnpj: "false" }));
			return;
		}
		if (values.cep.length !== 8) {
			setTextoErro("CEP inválido");
			setOpenToastErro(true);
			setValidator((current) => ({ ...current, validatorCep: "false" }));
			return;
		}

		setLoading(true);
		await editaClientePorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (valuesPesquisa.pesquisa === undefined) {
						buscarEmbarcador();
					} else {
						buscarSearch();
					}
					setTabelaRedux({});
					showToast("Editado Com Sucesso", "success");
					setTelaCadastro(false);
					setMarker(null);
					setEditando(false);
					setValues({});
					setDisableInputs(true);
					setDisabledCep(true);
					if (!!props.onCloseModal) {
						props.onCloseModal();
					}
				}
			})
			.catch((error) => {
				showToast(
					typeof error.response.data === "string"
						? error.response.data
						: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					"error"
				);
			});
		setLoading(false);
	}, [
		values,
		profile?.token,
		valuesPesquisa.pesquisa,
		buscarEmbarcador,
		buscarSearch,
		setTabelaRedux,
	]);

	const buscarEmbarcadorPorId = useCallback(async () => {
		setLoading(true);
		if (tabelaRedux.colunaSelecionada) {
			await getClientePorId(tabelaRedux.colunaSelecionada, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						if (editando) {
							const minutos = parseFloat(result.data.tempoDiariaMinutos);
							const horas = isNaN(minutos) ? "" : (minutos / 60).toFixed(0);
							setValues((current) => ({
								...current,
								tempoDiariaMinutos: minutos,
								tempoDiariaMinutosV: horas,
								idCliente: result.data.idCliente,
								nomeFantasia: result.data.nomeFantasia,
								razaoSocial: result.data.razaoSocial,
								cnpj: result.data.cnpj,
								corCliente: result.data.corCliente,
								apelido: result.data.apelido,
							}));
							if (!!result.data.endereco) {
								setValues((current) => ({
									...current,
									rua: result.data.endereco.rua,
									numero: result.data.endereco.numero ?? 0,
									cidade: result.data.endereco.cidade,
									cep: result.data.endereco.cep,
									bairro: result.data.endereco.bairro,
									complemento: result.data.endereco.complemento,
								}));
								setClienteLatLng({
									lat:
										result.data.endereco?.polygon[0]?.latitude ||
										clienteLatLng.lat,
									lng:
										result.data.endereco?.polygon[0]?.longitude ||
										clienteLatLng.lng,
								});
								if (result.data.endereco.polygon.length <= 1) {
									setLat(
										result.data.endereco?.polygon[0]?.latitude ||
											clienteLatLng.lat
									);
									setLng(
										result.data.endereco?.polygon[0]?.longitude ||
											clienteLatLng.lng
									);
									setMarker({
										lat:
											result.data.endereco?.polygon[0]?.latitude ||
											clienteLatLng.lat,
										lng:
											result.data.endereco?.polygon[0]?.longitude ||
											clienteLatLng.lng,
									});
									const coordenadasTransformadas2 =
										result.data.endereco.polygon.map((coordenada) => ({
											latitude: coordenada.latitude || clienteLatLng.lat,
											longitude: coordenada.longitude || clienteLatLng.lng,
										}));
									setValues((current) => ({
										...current,
										polygon: coordenadasTransformadas2,
									}));
									setZoom(14);
								} else {
									const coordenadasTransformadas =
										result.data.endereco.polygon.map((coordenada) => ({
											lat: coordenada.latitude || clienteLatLng.lat,
											lng: coordenada.longitude || clienteLatLng.lng,
										}));
									const coordenadasTransformadas2 =
										result.data.endereco.polygon.map((coordenada) => ({
											latitude: coordenada.latitude || clienteLatLng.lat,
											longitude: coordenada.longitude || clienteLatLng.lng,
										}));
									setValues((current) => ({
										...current,
										polygon: coordenadasTransformadas2,
									}));
									setPolygon({ paths: coordenadasTransformadas });
									setLat(coordenadasTransformadas[0].lat || clienteLatLng.lat);
									setLng(coordenadasTransformadas[0].lng || clienteLatLng.lng);
									setMarker({
										lat: coordenadasTransformadas[0].lat || clienteLatLng.lat,
										lng: coordenadasTransformadas[0].lng || clienteLatLng.lng,
									});
									setZoom(11);
								}
							} else {
								setLat(clienteLatLng.lat);
								setLng(clienteLatLng.lng);
							}
						}
					}
				})
				.catch((error) => {
					if (!editando) {
						if (typeof error.response.data === "string") {
							setTextoErro(error.response.data);
						} else {
							setTextoErro(
								"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
							);
						}
						setOpenToastErro(true);
					}
				});
		}
		setLoading(false);
	}, [tabelaRedux.colunaSelecionada, profile?.token, editando]);

	const buscarEmbarcadorPorIdModal = useCallback(
		async (id) => {
			setLoading(true);
			await getClientePorId(id, profile?.token)
				.then(async (result) => {
					if (result.status === 200) {
						setValues(result.data);
					}
				})
				.catch((error) => {
					if (!editando) {
						if (typeof error.response.data === "string") {
							setTextoErro(error.response.data);
						} else {
							setTextoErro(
								"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
							);
						}
						setOpenToastErro(true);
					}
				});
			setLoading(false);
		},
		[profile?.token, editando]
	);

	const deletarEmbarcadorPorId = useCallback(async () => {
		setLoading(true);
		await deleteClientePorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarEmbarcador();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
		setLoading(false);
	}, [
		tabelaRedux.colunaSelecionada,
		profile?.token,
		buscarEmbarcador,
		setTabelaRedux,
	]);

	const handleMapLoaded = useCallback((map) => {
		setMapInstance(map);
		setIsMapLoaded(true);
	}, []);

	const handleMapClickPoint = useCallback((event) => {
		if (!event || !event.latLng) {
			console.error("Erro: Evento de clique inválido.", event);
			return;
		}
		const lat = event.latLng.lat();
		const lng = event.latLng.lng();

		setDisableInputs(false);
		setDisabledCep(false);

		fetchAddressFromCoords(lat, lng);
	}, []);

	const handleMapClickPoligon = useCallback((event) => {
		const lat = event.latLng.lat();
		const lng = event.latLng.lng();
		const novoPonto = { latitude: lat, longitude: lng };

		setValues((current) => {
			setShowFirstPointMarker(!current.polygon?.length);
			return {
				...current,
				polygon: [{ latitude: lat, longitude: lng }],
			};
		});

		setDisableInputs(false);
		setDisabledCep(false);

		setPolygon((prevPolygon) => ({
			...prevPolygon,
			paths: [...prevPolygon.paths, novoPonto],
		}));

		fetchAddressFromCoords(lat, lng);
	}, []);

	const handleTipoGeometria = useCallback(() => {
		setPolygon({ paths: [] });

		if (drawnPolygon) {
			drawnPolygon.setMap(null);
			setDrawnPolygon(null);
		}
		setDisableInputs(false);
		setDisabledCep(false);

		setValues((current) => {
			return {
				...current,
				latitude: null,
				longitude: null,
				polygon: null,
			};
		});

		setTipoGeometria(!tipoGeometria);
	}, [tipoGeometria, removePolygon, values.polygon]);

	const handleClose = useCallback(() => {
		setOpen(false);
	}, []);

	const handleCloseToastSucesso = useCallback(() => {
		setOpenToastSucesso(false);
	}, []);

	const handleCloseToastErro = useCallback(() => {
		setOpenToastErro(false);
	}, []);

	const handleCloseUsuarioMotorista = useCallback(() => {
		setOpenUsuarioMotorista(false);
		setOpenConfirmar(false);
		buscarEmbarcador();
	}, [buscarEmbarcador]);

	const abrirConfirmar = useCallback(() => {
		setOpenConfirmar(true);
	}, []);

	const handleCloseConfirmar = useCallback(() => {
		setOpenConfirmar(false);
	}, []);

	const clickGerar = useCallback(() => {
		gerarUsuario();
	}, [gerarUsuario]);

	const handleCloseGerar = useCallback(() => {
		setOpenGerar(false);
	}, []);

	const validarFormulario = useCallback(() => {
		if (!dadosFormularioValido) {
			validaDadosCliente();
			validaEnderecoCliente();
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
			return false;
		}

		if (enderecoParcialmentePreenchido && !enderecoTotalmentePreenchido) {
			setTextoErro("Endereço é Obrigatório!");
			setOpenToastErro(true);
			setLoading(false);
			return false;
		}

		return true;
	}, [
		dadosFormularioValido,
		enderecoParcialmentePreenchido,
		enderecoTotalmentePreenchido,
		validaDadosCliente,
		validaEnderecoCliente,
	]);

	const handleSalvarCliente = useCallback(async () => {
		setOpenToastErro(false);
		if (!documentoValido(values.cnpj)) {
			setTextoErro("CPF/CNPJ inválido");
			setOpenToastErro(true);
			setValidator((current) => ({ ...current, validatorCnpj: "false" }));
			return;
		}

		setLoading(true);

		try {
			var response;
			if (values.polygon) {
				if (!validarFormulario()) {
					return;
				}
				if (editando) {
					response = await editar();
				} else {
					response = await cadastrar();
				}
			} else {
				setTextoErro("Selecione um ponto no mapa ou preencha o endereço!");
				setOpenToastErro(true);
			}
			if (response?.status === 200) {
				setValidator((current) => ({
					...current,
					validatorApelido: "true",
					validatorNomeFantasia: "true",
					validatorRazaoSocial: "true",
				}));
				setError(false);
			}
		} catch (error) {
			setError(true);
			console.error("Erro ao salvar cliente:", error);
		}

		setLoading(false);
	}, [validarFormulario, editando, editar, cadastrar]);

	const handleChangeDocumento = useCallback(
		(e) => {
			let valorMascara = e.target.value.replace(/\D+/g, "");
			if (valorMascara.length <= 11) {
				valorMascara = cpfMask(valorMascara);
			} else {
				valorMascara = cnpjMask(valorMascara);
			}
			setValues((current) => ({
				...current,
				cnpj: valorMascara,
			}));
			setValidator((current) => ({
				...current,
				validatorCnpj: "true",
			}));
		},
		[values]
	);

	const handleSingleClick = useCallback(
		(row) => {
			if (!row) return;
			setTabelaRedux({
				colunaSelecionada: row.idCliente,
				usuarioAlteracao: row.usuario || row.usuarioAlteracao || null,
				dataAlteracao: row.data || row.dataAlteracao || null,
				row,
			});
		},
		[setTabelaRedux]
	);

	const handleDoubleClick = useCallback(() => {
		setTelaCadastro(true);
		setEditando(true);
	}, [setEditando, setTelaCadastro]);

	const handleRowClick = useRowClick({
		idKey: "idCliente",
		onSelect: handleSingleClick,
		onDouble: handleDoubleClick,
	});

	const getRowClassName = useCallback(
		(row) => {
			if (!tabelaRedux?.colunaSelecionada) return "";
			return row.idCliente === tabelaRedux.colunaSelecionada
				? "selecionado"
				: "";
		},
		[tabelaRedux?.colunaSelecionada]
	);

	useEffect(() => {
		if (editando) {
			buscarEmbarcadorPorId();
			setIsMapa(true);
			setDisableCnpj(true);
			return;
		}
		setDisableCnpj(false);
	}, [editando, buscarEmbarcadorPorId]);

	useEffect(() => {
		if (profile?.token && props.idAtual) {
			buscarEmbarcadorPorIdModal(props.idAtual);
		}
	}, [profile?.token, props.idAtual]);

	useEffect(() => {
		if (props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Clientes"));
			setSemAutorizacaoGerarLogin(!hasRegra("Gerar Login"));
			buscarEmbarcador();
			buscarUsuariosClientes();
		}
	}, [profile?.token]);

	useEffect(() => {
		setValidator({
			validatorCnpj: "true",
			validatorApelido: "true",
			validatorNomeFantasia: "true",
			validatorRazaoSocial: "true",
			validatorRua: "true",
			validatorCidade: "true",
			validatorCep: "true",
		});
		setValues((current) => ({
			...current,
			rua: "",
			numero: 0,
			cidade: "",
			cep: "",
			bairro: "",
			razaoSocial: "",
			nomeFantasia: "",
			apelido: "",
			cnpj: "",
			tempoDiariaMinutos: 0,
		}));
		setClienteLatLng({
			lat: defaultLat,
			lng: defaultLng,
		});
	}, [telaCadastro, editando]);

	useEffect(() => {
		if (isMapLoaded && polygon && polygon.paths && polygon.paths.length > 0) {
			if (drawnPolygon) {
				drawnPolygon.setMap(null);
			}

			const newPolygon = new window.google.maps.Polygon({
				paths: polygon.paths,
				strokeColor: "#FF0000",
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: "#FF0000",
				fillOpacity: 0.35,
			});

			newPolygon.setMap(mapInstance);
			setDrawnPolygon(newPolygon);
		}
	}, [polygon, isMapLoaded, drawnPolygon, mapInstance]);

	const limpar = useCallback(() => {
		setLoading(true);
		setValuesPesquisa([]);
		setDadosTabela(dadosTabelaCopia);
		setTimeout(() => {
			setLoading(false);
		}, 100);
	}, [dadosTabelaCopia]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer animationKey="ClienteScreenContainer">
						<div className="content-container">
							<Separator size="md" />
							<FiltroV2
								classe="div-filtrar-embarque-v2"
								classOption="select-options-cliente"
								itensFiltro={itensFiltro}
								valuesPesquisa={valuesPesquisa}
								setValuesPesquisa={setValuesPesquisa}
								buscarSearch={buscarSearch}
								limpar={limpar}
							/>
							<Separator size="md" />
							<TabelaVirtualizadaGenerica
								dados={dadosTabela}
								isLoading={loading}
								colunas={colunasEmpresaInicial.Cliente}
								rowHeight={20}
								getRowClassName={getRowClassName}
								onRowClick={handleRowClick}
							/>
						</div>
						<div className="footer-container">
							<CustomButtonV2
								classCss="custom-button-cadastrar"
								classText="button-texto-cadastrar"
								icone="iconeSave"
								titulo="Cadastrar"
								cor="#0946B8"
								valor={values}
								onClick={() => {
									setTelaCadastro(true);
									setEditando(false);
								}}
							/>
							<CustomButtonV2
								classCss="custom-button-editar"
								classText="button-texto-editar"
								titulo="Editar"
								icone="iconeEdit"
								cor="#CDCDCD"
								valor={values}
								onClick={() => {
									if (tabelaRedux.colunaSelecionada) {
										setTelaCadastro(true);
										setEditando(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
							<CustomButtonV2
								classCss="custom-button-deletar"
								classText="button-texto-cadastrar"
								titulo="Deletar"
								icone="iconeDelete"
								cor="#DC2D2D"
								valor={values}
								onClick={() => {
									if (tabelaRedux.colunaSelecionada) {
										setOpen(true);
										setTextoSucesso("Deletado Com Sucesso");
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
							<CustomButtonV2
								classCss="custom-button-user"
								classText="button-texto-user"
								titulo="Obter Usuário"
								cor="#FFFFFF"
								valor={values}
								onClick={() => {
									if (tabelaRedux.usuarioAlteracao) {
										setOpenUsuario(true);
									} else {
										setTextoErro("Selecione Uma Coluna");
										setOpenToastErro(true);
									}
								}}
							/>
							{!!semAutorizacaoGerarLogin && (
								<div>
									<CustomButtonV2
										classCss="custom-button-vincular"
										classText="button-texto-user"
										titulo="Vincular Usuário"
										cor="#FFFFFF"
										valor={values}
										onClick={() => {
											if (tabelaRedux.colunaSelecionada) {
												setOpenGerar(true);
											} else {
												setTextoErro("Selecione Uma Coluna");
												setOpenToastErro(true);
											}
										}}
									/>
								</div>
							)}
						</div>
					</MotionContainer>
				) : (
					<MotionContainer scroll animationKey="ClienteCadastroScreenContainer">
						<div className="content-container-scrollable">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">{"Dados de Clientes / "}</p>
										{editando ? (
											<p className="indicador-emb">{"Detalhes de Clientes"}</p>
										) : (
											<p className="indicador-emb">{"Cadastro de Clientes"}</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									{!props.botaoFechar && (
										<div className="close-btn">
											<CloseIcon onClick={handleCloseCadastro} />
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div
										style={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											gap: 14,
										}}
									>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Nome Fantasia:
												</p>
												<input
													type="text"
													id="nomeFantasia"
													className="input-emb"
													style={{
														width: "210px",
														borderColor:
															validator.validatorNomeFantasia === "false"
																? "red"
																: "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nomeFantasia: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															validatorNomeFantasia: "true",
														}));
													}}
													placeholder="Ex: BRF"
													value={values.nomeFantasia || ""}
													disabled={props.desabilitar}
												/>
												{validator.validatorNomeFantasia === "false" && (
													<p className="error-input-text">
														Nome Fantasia inválido
													</p>
												)}
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Razão Social:
												</p>
												<input
													type="text"
													id="razaoSocial"
													className="input-emb"
													style={{
														width: "210px",
														borderColor:
															validator.validatorRazaoSocial === "false"
																? "red"
																: "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															razaoSocial: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															validatorRazaoSocial: "true",
														}));
													}}
													placeholder="Ex: BRF S.A"
													value={values.razaoSocial || ""}
													disabled={props.desabilitar}
												/>
												{validator.validatorRazaoSocial === "false" && (
													<p className="error-input-text">
														Razão Social inválida
													</p>
												)}
											</div>
										</div>
										<div className="input-box-container">
											<div
												className="input-container"
												style={{ alignItems: "flex-start" }}
											>
												<p className="input-label-emb" htmlFor="descricao">
													CPF/CNPJ:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "210px",
														borderColor:
															validator.validatorCnpj === "false" ? "red" : "",
													}}
													onChange={handleChangeDocumento}
													placeholder="Ex: 00.000.000/0000-00"
													value={values.cnpj || ""}
													disabled={props.desabilitar}
												/>
												{validator.validatorCnpj === "false" && (
													<p className="error-input-text">CNPJ/CPF inválido</p>
												)}
											</div>
										</div>

										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Apelido:
												</p>
												<input
													type="text"
													id="apelido"
													className="input-emb"
													style={{
														width: "210px",
														borderColor:
															validator.validatorApelido === "false"
																? "red"
																: "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															apelido: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															validatorApelido: "true",
														}));
													}}
													placeholder="Ex: BRF"
													maxLength={12}
													value={values.apelido || ""}
													disabled={props.desabilitar}
												/>
												{validator.validatorApelido === "false" && (
													<p className="error-input-text">Apelido inválido</p>
												)}
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Tempo Diária:
												</p>
												<input
													type="number"
													id="apelido"
													className="input-emb"
													style={{ width: "210px" }}
													onChange={(e) => {
														const horas = parseFloat(e.target.value);
														const minutos = isNaN(horas)
															? ""
															: Math.floor(horas * 60);
														setValues((current) => ({
															...current,
															tempoDiariaMinutos: minutos,
														}));
														setValues((current) => ({
															...current,
															tempoDiariaMinutosV: horas,
														}));
													}}
													placeholder="Ex: 24 horas"
													maxLength={5}
													value={values.tempoDiariaMinutosV || ""}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="principal-cliente">
								<div className="box2">
									<div className="flex-row">
										<CustomButtonV2
											classCss="custom-button-mapa"
											classText="button-texto-user"
											titulo="Selecionar Endereço no Mapa"
											cor="#FFFFFF"
											onClick={() => {
												setIsMapa(!isMapa);
											}}
										/>
									</div>
									<Separator size="lg" />
									{isMapa && (
										<div className="principal-mapa-v2">
											{loadError && <div>Erro ao carregar o mapa</div>}
											{!isLoaded ? (
												<LoadingComponent />
											) : (
												<>
													<StandaloneSearchBox
														onLoad={(ref) => (searchBoxRef.current = ref)}
														onPlacesChanged={handlePlacesChanged}
													>
														<input
															type="text"
															placeholder="Selecione um endereço"
															className="search-box"
														/>
													</StandaloneSearchBox>
													<div className="geometria-card">
														<CustomButtonV2
															classCss="custom-button-geometria"
															classText="button-texto-user"
															titulo={tipoGeometria ? "Ponto" : "Polígono"}
															cor="#FFFFFF"
															onClick={() => {
																handleTipoGeometria();
															}}
														/>
													</div>
													<GoogleMap
														mapContainerStyle={{
															width: "100%",
															height: "56vh",
															paddingTop: "10px",
														}}
														zoom={zoom}
														center={{ lat, lng }}
														onLoad={handleMapLoaded}
														onClick={
															tipoGeometria
																? handleMapClickPoligon
																: handleMapClickPoint
														}
													>
														{markerPosition && mapInstance && (
															<Marker
																position={markerPosition}
																map={mapInstance}
															/>
														)}
													</GoogleMap>
												</>
											)}
										</div>
									)}
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Rua:
												</p>
												<input
													type="text"
													id="rua"
													className="input-emb"
													style={{
														width: "250px",
														borderColor:
															validator.validatorRua === "false" ? "red" : "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															rua: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															validatorRua: "true",
														}));
													}}
													value={values.rua || ""}
													disabled={props.desabilitar || disableInputs}
												/>
												{validator.validatorRua === "false" && (
													<p className="error-input-text">Rua inválida</p>
												)}
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Número:
												</p>
												<input
													id="numero"
													className="input-emb"
													style={{ width: "250px" }}
													onChange={(e) => {
														const value =
															e.target.value === "" ? 0 : e.target.value;
														setValues((current) => ({
															...current,
															numero: value,
														}));
													}}
													value={values.numero || 0}
													disabled={props.desabilitar || disableInputs}
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="Bairro">
													Bairro:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "250px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															bairro: e.target.value,
														}));
													}}
													value={values.bairro || ""}
													disabled={props.desabilitar || disableInputs}
												/>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													CEP:
												</p>
												<input
													maxLength="8"
													type="text"
													id="cep"
													className="input-emb"
													style={{
														width: "250px",
														borderColor:
															validator.validatorCep === "false" ? "red" : "",
													}}
													onChange={(e) => {
														let valor = e.target.value;
														valor = valor.replace(/\D/g, "");
														setValues((current) => ({
															...current,
															cep: valor,
														}));
														setValidator((current) => ({
															...current,
															validatorCep: "true",
														}));
													}}
													onBlur={(e) => {
														const cep = e.target.value;
														if (!/^\d{8}$/.test(cep)) {
															setValidator((current) => ({
																...current,
																validatorCep: "false",
															}));
															setTextoErro("CEP inválido");
															setOpenToastErro(true);
														}
													}}
													value={values.cep || ""}
													disabled={props.desabilitar || disabledCep}
												/>
												{validator.validatorCep === "false" && (
													<p className="error-input-text">CEP inválido</p>
												)}
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Cidade:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "250px",
														borderColor:
															validator.validatorCidade === "false"
																? "red"
																: "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															cidade: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															validatorCidade: "true",
														}));
													}}
													value={values.cidade || ""}
													disabled={props.desabilitar || disableInputs}
												/>
												{validator.validatorCidade === "false" && (
													<p className="error-input-text">Cidade inválida</p>
												)}
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Complemento:
												</p>
												<input
													type="text"
													id="complemento"
													className="input-emb"
													style={{ width: "250px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															complemento: e.target.value,
														}));
													}}
													value={values.complemento || ""}
													disabled={props.desabilitar || disableInputs}
												/>
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div>
											<InputLabel htmlFor="cnpj">Cor Cliente</InputLabel>
											<ChromePicker
												className="picker"
												color={
													values.corCliente ? values.corCliente : "#000000"
												}
												onChange={(updatedColor) =>
													setValues((current) => ({
														...current,
														corCliente: updatedColor?.hex,
													}))
												}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={handleSalvarCliente}
								/>
							) : (
								<>
									{!props.desabilitar ? (
										props.botaoCadastrar ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={handleSalvarCliente}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={handleSalvarCliente}
											/>
										)
									) : (
										<></>
									)}
								</>
							)}
							{props.botaoVoltar ? (
								<></>
							) : (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={handleCloseCadastro}
								/>
							)}
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<ModalConfirmacao
				titulo="Deletar"
				texto="Deseja Deletar?"
				tituloConfirmar="Confirmar"
				tituloCancelar="Cancelar"
				open={open}
				onClose={handleClose}
				onClick={deletarEmbarcadorPorId}
			/>
			<ModalUsuario
				titulo="Usuário"
				tituloConfirmar="OK"
				open={openUsuario}
				onClose={() => setOpenUsuario(false)}
			/>
			<ModalUsuarioMotorista
				titulo="Login Motorista"
				tituloConfirmar="OK"
				open={openUsuarioMotorista}
				onClose={abrirConfirmar}
				dados={dadosUsuarioMotorista}
			/>
			<ModalConfirmacao2
				titulo="Deseja Fechar? "
				texto="Ao fechar esse modal não será mais possivel visalizar a senha."
				textoBotao="Sim"
				open={openConfirmar}
				onClose={handleCloseConfirmar}
				onClick={handleCloseUsuarioMotorista}
			/>
			<ModalVincular
				titulo="Vincular Usuário"
				tituloConfirmar="Confirmar"
				tituloCancelar="Cancelar"
				open={openGerar}
				onClose={handleCloseGerar}
				onClick={clickGerar}
				listaUsuarios={listaUsuarios}
				setUsuarioId={setUsuarioId}
				setNomeUsuario={setNomeUsuario}
				referenciaId="nome"
				referenciaItem="nome"
				id="id"
			/>

			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</Layout>
	);
}

export default Cliente;
